function removeLeadingSlash(s) {
  if (s.substring(0, 1) === '/') {
    s = s.substring(1);
  }

  return s;
}

module.exports = removeLeadingSlash;



//////////////////
// WEBPACK FOOTER
// ./~/react-ga/src/utils/removeLeadingSlash.js
// module id = 1062
// module chunks = 0